module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n    "), _c('a', {
    attrs: {
      "href": "https://www.solidtectecnologia.com.br"
    }
  }, [_vm._v("Solidtec Tecnologia")])]), _vm._v(" "), (_vm.flag === 'es') ? _c('span', [_vm._v(". Todos los derechos reservados.")]) : (_vm.flag === 'de') ? _c('span', [_vm._v(". Alle rechte vorbehalten.")]) : (_vm.flag === 'us') ? _c('span', [_vm._v(". All rights reserved.")]) : _c('span', [_vm._v(". Todos os direitos reservados.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a52a7b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashFooter.vue
// module id = 329
// module chunks = 1